<template>
    <div class="page-item-wrapper">
        <BackDrop @click="showModal = false" v-if="showModal" />
        <div
            :class="['page-item', { dark: theme == THEMES.DARK }, { active }]"
            @click="handlePageClick(page)"
        >
            <div>
                {{ page }}
            </div>
        </div>
        <div class="page-input" v-if="page == '...' && showModal">
            <div class="mb-3 d-flex align-items-start justify-content-between">
                <div>Go to Page (1 - {{ lastPage }})*`</div>
                <div @click="showModal = false"><i class="fas fa-times"></i></div>
            </div>
            <CustomInput v-model="customPage" placeholder="Enter Page" type="number" />
            <Button @click="handlePageClick(customPage)">Go</Button>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex"
import BackDrop from "../BackDrop.vue"
import CustomInput from "../crud/custom-input.vue"
import Button from "../UI/Button.vue"

export default {
    emits: ["change"],
    data() {
        return { showModal: false, customPage: "" }
    },
    props: {
        lastPage: { type: Number, default: () => 1 },
        page: { type: [Number, String], default: () => 1 },
        active: { type: Boolean, default: () => false },
    },
    mounted() {},
    computed: {
        ...mapState("misc", ["theme", "THEMES"]),
    },
    methods: {
        handlePageClick(page) {
            console.log("handle page click", page)
            if (page === "...") {
                this.showModal = true
            } else {
                page = Number(page)
                if (page > 0 && page <= this.lastPage) {
                    this.$emit("change", page)
                    this.showModal = false
                } else {
                    this.$toast.error("Please enter a valid page!")
                }
            }
        },
    },
    components: { Button, CustomInput, BackDrop },
}
</script>

<style lang="scss">
@import "@/assets/variables.scss";

.page-item-wrapper {
    position: relative;
    
    .page-input {
        position: absolute;
        background: $lightCardBg;
        padding: 16px;
        width: 240px;
        bottom: calc(100% + 10px);
        border: 1px solid $lightBorderColor;
        border-radius: 8px;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
        z-index: 10;
        
        .dark & {
            background: $darkCardBg;
            border-color: $darkBorderColor;
            color: $darkTextColor;
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
        }
    }
}

.page-item {
    width: 36px;
    height: 36px;
    font-size: 14px;
    font-weight: 500;
    margin: 0 3px;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid $lightBorderColor;
    border-radius: 6px;
    background-color: $lightCardBg;
    color: $textColor;
    cursor: pointer;
    transition: all 0.2s ease-in-out;

    &:hover {
        background-color: $lightHoverColor;
        border-color: $primaryColor;
    }
    
    &.active {
        background-color: $primaryColor;
        color: white;
        border-color: $primaryColor;
    }
    
    &.dark {
        background-color: $darkCardBg;
        border-color: $darkBorderColor;
        color: $darkTextColor;
        
        &:hover {
            background-color: rgba(255, 255, 255, 0.08);
            border-color: $secondaryColorDark;
        }
        
        &.active {
            background-color: $primaryColorDark;
            color: white;
            border-color: $primaryColorDark;
        }
    }
}
</style>
